import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { getToysiCategories, getToysiProducts, getToysiImportedSkus } from 'services/toysi.service';

export const toysiCategoriesQueryKey = 'toysiCategories';
export const toysiProductsQueryKey = 'toysiProducts';
export const toysiImportedSkusQueryKey = 'toysiImportedSkus';

export const useToysiCategories = () => useQuery(
  [toysiCategoriesQueryKey],
  () => getToysiCategories().then((r: AxiosResponse) => r.data),
  { refetchOnWindowFocus: false, retry: false },
);

export const useToysiProducts = (categoryId: string | null) => useQuery(
  [toysiProductsQueryKey, categoryId],
  () => getToysiProducts(categoryId!).then((r: AxiosResponse) => r.data),
  { enabled: !!categoryId, refetchOnWindowFocus: false, retry: false },
);

export const useToysiImportedSkus = () => useQuery(
  [toysiImportedSkusQueryKey],
  () => getToysiImportedSkus().then((r: AxiosResponse) => r.data as string[]),
  { refetchOnWindowFocus: false, retry: false },
);
